/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_TestInputs */

const en_byoa_test = /** @type {(inputs: Byoa_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test connection`)
};

const id_byoa_test = /** @type {(inputs: Byoa_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uji koneksi`)
};

/**
* | output |
* | --- |
* | "Test connection" |
*
* @param {Byoa_TestInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_test = /** @type {((inputs?: Byoa_TestInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_TestInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_test(inputs)
	return en_byoa_test(inputs)
});